/// <reference path='docs-and-forms.module.ts' />
///<reference path="docs-and-forms.models.ts"/>
/// <reference path='../../../../typings/index.d.ts' />
///<reference path="../../components/baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../components/common/messages.ts"/>

module Meevo.Plugins.DocsAndForms {
    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;
    import AppointFinalStateEnum = Meevo.Model.AppointFinalStateEnum;

    import AppointmentServiceScheduleStep = Meevo.Model.AppointmentServiceScheduleStep;

    import IUserDefinedControl = Meevo.Model.IUserDefinedControl;
    import SecurityEntityTypeEnum = Meevo.Model.SecurityEntityTypeEnum;
    import Moment = moment.Moment;

    export interface IDocsAndFormsService {
        showForm(form: IShowFormOptionRow, clientId: string, appointmentId?: string, iframeCallback?: Function): ng.IPromise<void>;
        populateAssignedUdfs(data: IUserDefinedControl[], model: IDocsAndFormsModel): IDocsAndFormAssignedCFF[];
        populateServiceWithData(service: IClientFormService, locationTime: Moment, serviceStartDateTime: string | Date, finalState?: AppointFinalStateEnum): IClientFormService;
        groupFormsByClientAndService(forms: IClientFormService[], appointmentServices: IAS[], formCollectionState: FormCollectionStateEnum): IClientRow[];
        buildFormsAndClients(forms: IClientFormService[], appointmentServices: IAS[], formCollectionState: FormCollectionStateEnum): ng.IPromise<IClientRow[]>;
        groupFormsByService(forms: IClientFormService[]): IGroupedByServiceForm[];
    }

    export interface IClientRow {
        clientFirstName: string;
        clientLastName: string;
        clientId: string;
        services: Partial<IGroupedByServiceForm>[];
    }

    export enum FormCollectionStateEnum {
        Booking,
        Checkin,
        SmartAssistant
    }

    export interface IAS {
        startDateTime: string | Date;
        serviceDisplayName: string;
        finalState: Model.AppointFinalStateEnum;
        id: string;
        clientId: string;
        serviceId: string;
        steps?: AppointmentServiceScheduleStep[];
    }

    declare var screenfull: any;

    export class DocsAndFormsService implements IDocsAndFormsService {

        static factory(): Function {
            const instance = (dataService: Meevo.Components.CommonClasses.ICommonDataService,
                              modalService: Meevo.Components.Modal.IModalService,
                              $rootScope: ng.IRootScopeService,
                              docsAndFormsApiService: DocsAndFormsApiService,
                              appSettings: Meevo.Components.Common.IAppSettings,
                              busyService: Meevo.Components.Busy.IBusyService,
                              $q: ng.IQService,
                              $sce: ng.ISCEService,
                              $state: ng.ui.IStateService) => {
                return new DocsAndFormsService(
                    dataService,
                    modalService,
                    $rootScope,
                    docsAndFormsApiService,
                    appSettings,
                    busyService,
                    $q,
                    $sce,
                    $state
                );
            };

            instance.$inject = [
                'meevo.components.common.DataService',
                'meevo.components.modal.ModalService',
                '$rootScope',
                'meevo.plugins.docsAndForms.DocsAndFormsApiService',
                'meevo.AppSettings',
                'meevo.components.busy.BusyService',
                '$q',
                '$sce',
                '$state'
            ];

            return instance;
        }

        constructor(protected dataService: Meevo.Components.CommonClasses.ICommonDataService,
                    protected modalService: Meevo.Components.Modal.IModalService,
                    protected $rootScope: ng.IRootScopeService,
                    protected docsAndFormsApiService: DocsAndFormsApiService,
                    protected appSettings: Meevo.Components.Common.IAppSettings,
                    private busyService: Meevo.Components.Busy.IBusyService,
                    private $q: ng.IQService,
                    private $sce: ng.ISCEService,
                    protected $state: ng.ui.IStateService
        ) {
        }

        isMobile(): boolean {
            if (window.innerWidth <= 1112 && window.innerHeight <= 834) {
                return true;
            } else {
                return false;
            }
        }

        populateAssignedUdfs(data: IUserDefinedControl[], model: IDocsAndFormsModel): IDocsAndFormAssignedCFF[] {
            return data.map((row) => {
                const selected = model.originalBuilderHTML.indexOf(row.control_TId.toString()) !== -1;

                return new DocsAndFormAssignedUDFItem(<IDocsAndFormAssignedCFF>{
                    ...row,
                    selected
                });
            });
        }

        showForm(form: IShowFormOptionRow, clientId: string, appointmentId ?: string, iframeCallback: Function = null): ng.IPromise<void> {
            let defer = this.$q.defer<void>();

            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.docsAndFormsKiosk,
                stateParams: {
                    form,
                    clientId,
                    appointmentId,
                    iframeCallback,
                    deferCallback: defer,
                    callbackState: this.$state.current.name
                },
            });

            return defer.promise;
        }

        getUnSubmittedValidForms(appointmentServiceIds: string[]): ng.IPromise<IClientFormService[]> {
            let request = {
                AppointmentServicesList: appointmentServiceIds,
                TriggerEventEnum: Meevo.Model.DocsAndFormsTriggerEventEnum.Booked,
                isBuilt: true
            };

            // Bug 109001 fix - The backend sets isSubmitted to false for expired forms - we trust that flag here
            // The backend is using location-specific time information so it does not need to be repeated on the client
            return this.docsAndFormsApiService.getAppointmentServiceFormList(request)
                .then(forms => forms.filter(form => !form.isSubmitted));
        }

        showAddCustomFormFieldModal(formModel: IDocsAndFormsModel): ng.IPromise<IUserDefinedControl> {
            const options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/docsAndForms/components/custom-form-fields/add-control.modal.html',
                controller: 'meevo.plugins.docsAndForms.DocsAndFormsAddControlModalController',
                controllerAs: 'vm',
                bindToController: true,
                escapeToClose: false,
                locals: {
                    isNotificationEnabled: false,
                    docsAndFormsModel: formModel
                }
            };

            return this.modalService.showCustom(options);
        }

        showEditCustomFormFieldModel(formModel: IDocsAndFormsModel, userDefinedControl: IUserDefinedControl): ng.IPromise<IUserDefinedControl> {
            const options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/docsAndForms/components/custom-form-fields/add-control.modal.html',
                controller: 'meevo.plugins.docsAndForms.DocsAndFormsAddControlModalController',
                controllerAs: 'vm',
                bindToController: true,
                escapeToClose: false,
                locals: {
                    docsAndFormsModel: formModel,
                    userDefinedControl: angular.copy(userDefinedControl)
                }
            };


            return this.modalService.showCustom(options);
        }

        showCopyCustomFormFieldModel(formModel: IDocsAndFormsModel, userDefinedControl: IUserDefinedControl): ng.IPromise<IUserDefinedControl> {
            const options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/docsAndForms/components/custom-form-fields/add-control.modal.html',
                controller: 'meevo.plugins.docsAndForms.DocsAndFormsAddControlModalController',
                controllerAs: 'vm',
                bindToController: true,
                escapeToClose: false,
                locals: {
                    docsAndFormsModel: formModel,
                    userDefinedControl: angular.copy(userDefinedControl)
                }
            };
            return this.modalService.showCustom(options);
        }

        removeCustomFormField(userDefinedControl: IUserDefinedControl) {
            return this.modalService
                .confirm('LABEL_REMOVE_UDF', ModalTranslationModes.Translate)
                .then(() => {
                    this.busyService.start();

                    return this.docsAndFormsApiService
                        .removeCustomFormField(userDefinedControl.entityVersion, userDefinedControl.control_TId)
                        .then(res => {
                            if (res.isWarning && res.responseStatus && res.responseStatus.message) {
                                this.modalService.alert(res.responseStatus.message);

                                throw new Error(res.responseStatus.message);
                            }
                            return res;
                        })
                        .finally(() => this.busyService.stop());
                });
        }
        undeleteCustomFormField(userDefinedControl: IUserDefinedControl) {
            return this.modalService
                .confirm('LABEL_UNDELETE_UDF', ModalTranslationModes.Translate)
                .then(() => {
                    this.busyService.start();

                    return this.docsAndFormsApiService
                        .undeleteCustomFormField(userDefinedControl.entityVersion, userDefinedControl.control_TId)
                        .then(res => {
                            if (res.isWarning && res.responseStatus && res.responseStatus.message) {
                                this.modalService.alert(res.responseStatus.message);

                                throw new Error(res.responseStatus.message);
                            }
                            return res;
                        })
                        .finally(() => this.busyService.stop());
                });
        }


        getGroupedClientForms(clientId: string, formFillType: FormFillTypeEnum): ng.IPromise<IClientForm[]> {
            return this.$q.all([
                this.docsAndFormsApiService.getSubmitedFormsByClientId(clientId, formFillType),
                this.dataService.customMethodData(`${this.appSettings.API_ROOT}/TimeClock/LocationTime`, 'GET', null)
            ]).then(([res, locationTimeData]) => {
                let locationTime = moment(locationTimeData.data.locationTime).startOf('day');

                res.forEach((item) => {
                    item.securityKey = `custom_entity_${SecurityEntityTypeEnum.DocsAndForms}_${item.formId}`;

                    item.services.forEach((service) => {
                        this.populateServiceWithData(service, locationTime, service.serviceDateTime, service.appointmentServiceFinalState);

                        switch (service.formFillTypeEnum) {

                            case FormAndDocsView.OnlyOnce: {
                                // one time form
                                // by default form requires attention
                                if (service.isSubmitted) {
                                    // form does not require attention
                                    item.requiresAttention = false;
                                }
                            }
                            case FormAndDocsView.EveryTime: {
                                // every time form
                                // by default form doesn't require attention
                                if (!service.isSubmitted) {
                                    // form requires attention
                                    item.requiresAttention = true;
                                }
                            }
                        }

                    });
                });

                return res;
            });
        }

        populateServiceWithData(service: IClientFormService, locationTime?: Moment, serviceStartDateTime?: string | Date, finalState: AppointFinalStateEnum = service.appointmentServiceFinalState): IClientFormService {
            service.appointmentIsCheckedOut = finalState === Model.AppointFinalStateEnum.CheckedOut;
            service.hasAnswers = service.pdfUrlHistoryList && service.pdfUrlHistoryList.length > 0;
            service.url = this.$sce.trustAsResourceUrl(service.formUrl);
            service.pdfUrl = this.$sce.trustAsResourceUrl(service.hasAnswers ? service.pdfUrlHistoryList[0].formPdfResourceObject.meevoFile.files[0].fileUrl : null);
            service.securityKey = `custom_entity_${SecurityEntityTypeEnum.DocsAndForms}_${service.id}`;

            if (locationTime) {
                service.appointmentInPast = !!serviceStartDateTime ? moment(serviceStartDateTime).endOf('day').isBefore(locationTime) : false;
            }

            return service;
        }

        groupFormsByClientAndService(forms: IClientFormService[], appointmentServices: IAS[], formCollectionState: FormCollectionStateEnum): IClientRow[] {
            const clients: IClientRow[] = [];
            const clientIds = Object.keys(_(forms).groupBy('clientId'));
            for (const clientId of clientIds) {
                const clientForms = _(forms).where({ clientId: clientId });
                const client: IClientRow = {
                    clientFirstName: clientForms[0].clientFirstName,
                    clientLastName: clientForms[0].clientLastName,
                    clientId: clientId,
                    services: []
                };

                if (formCollectionState === FormCollectionStateEnum.SmartAssistant) {
                    const clientServices = _(appointmentServices).where({ clientId: clientId });
                    for (const clientService of clientServices) {
                        const appointmentServiceForms = _(clientForms).where({ appointmentServiceId: clientService.id });
                        client.services.push(
                            ...this.groupFormsByService(appointmentServiceForms)
                        )
                    }
                } else {
                    client.services.push({
                        forms: clientForms
                    });
                }

                clients.push(client);
            }

            return clients;
        }

        groupFormsByService(forms: IClientFormService[]): IGroupedByServiceForm[] {
            const res: IGroupedByServiceForm[] = [];
            const appointmentServiceGroupedForms = _(forms).groupBy('appointmentServiceId');
            for (const appointmentServiceId in appointmentServiceGroupedForms) {
                const appointmentServiceForms = appointmentServiceGroupedForms[appointmentServiceId];
                const groupedByServiceForms = _(appointmentServiceForms).groupBy('service_TId');
                for (const service_TId in groupedByServiceForms) {
                    const formsList = groupedByServiceForms[service_TId];
                    const firstItem = formsList[0];

                    res.push({
                        serviceDisplayName: firstItem.serviceDisplayName,
                        startDateTime: firstItem.serviceDateTime,
                        forms: formsList,
                        appointmentServiceId: firstItem.appointmentServiceId,
                        serviceId: service_TId
                    });
                }
            }

            return res;
        }

        buildFormsAndClients(forms: IClientFormService[], appointmentServices: IAS[], formCollectionState: FormCollectionStateEnum): ng.IPromise<IClientRow[]> {
            return this.dataService.customMethodData(`${this.appSettings.API_ROOT}/TimeClock/LocationTime`, 'GET', null)
                .then((res) => {
                    let locationTime = moment(res.data.locationTime).startOf('day');

                    for (const form of forms) {
                        const appointmentService = _(appointmentServices).findWhere({ id: form.appointmentServiceId });
                        const serviceStartDateTime = appointmentService ? appointmentService.startDateTime : form.serviceDateTime;
                        this.populateServiceWithData(form, locationTime, serviceStartDateTime, appointmentService && appointmentService.finalState);
                    }

                    return this.groupFormsByClientAndService(
                        forms,
                        appointmentServices,
                        formCollectionState
                    );
                });
        }
    }

    angular.module('meevo.plugins.docsAndForms')
        .service('meevo.plugins.docsAndForms.DocsAndFormsService', DocsAndFormsService.factory());
}
